<template>
  <div class="page-panel">
    <div class="page-panel__header">
      <div class="page-panel-header__control">
        <el-button class="page-panel-header-control-button" size="mini" type="primary" @click="back">返回</el-button>
      </div>
      <div class="page-panel-header__title">招标管理</div>
    </div>
    <el-form ref="form" label-width="90px" class="page-panel__body">
      <table class="form-editor">
        <tr>
          <th>公告标题</th>
          <td>
            <el-input v-model="bidsParam.bidsName" placeholder="请输入公告标题"></el-input>
          </td>
        </tr>
        <tr>
          <th>公告类型</th>
          <td>
            <el-radio-group v-model="bidsParam.bidsType">
              <el-radio :label="1">
                招标公告
              </el-radio>
              <el-radio :label="2">
                备案告知
              </el-radio>
              <el-radio :label="3">
                招标动态
              </el-radio>
              <el-radio :label="4">
                政策法规
              </el-radio>
              <el-radio :label="0">
                普通公告
              </el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <th>发布时间</th>
          <td>
            <el-date-picker v-model="bidsParam.promTime" type="datetime" placeholder="选择发布时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </td>
        </tr>
        <tr>
          <th>内容编辑</th>
          <td>
            <!-- <ueditor :config="editorConfig" v-model="bidsParam.bidsBody"></ueditor> -->
            <editor v-model="bidsParam.bidsBody" :min-height="200" />
          </td>
        </tr>
        <tr>
          <th>关键字</th>
          <td>
            <new-tag :dynamicTags='dynamicTags'></new-tag>
          </td>
        </tr>
      </table>
      <div class="article_footer_control">
        <!-- 1：保存草稿 0：正常发布 -->
        <el-button type="primary" @click="addBids">发布</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import * as bidsApi from '@/api/adminApi/zh/tendering';
export default {
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      dynamicTags: [],
      editorConfig: {
        initialFrameWidth: '100%',
        initialFrameHeight: 300,
        zIndex: 0
      },
      bidsParam: {
        bidsType: 1,
        // 默认当前时间
        promTime: this.$options.filters.toDate(
          new Date(),
          'yyyy-MM-dd hh:mm:ss'
        )
      }
    };
  },
  methods: {
    back() {
      this.$router.push({
        name: 'article',
        params: {
          activeTab: '招标管理'
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.dialogImageUrl = res.url;
      this.bidsParam.picMain = res.url;
    },
    addBids() {
      if (this.dynamicTags.length >= 1) {
        this.bidsParam.bidsKeys = this.dynamicTags.join(',');
      }
      bidsApi.addBids({ ...this.bidsParam }).then(res => {
        this.$router.push({
          name: 'article',
          params: {
            activeTab: '招标管理'
          }
        });
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.cropper-content {
  .cropper {
    width auto
    height 300px
  }
}
.el-tag + .el-tag {
  margin-left 10px
}
.button-new-tag {
  margin-left 10px
  height 32px
  line-height 30px
  padding-top 0
  padding-bottom 0
}
.input-new-tag {
  width 90px
  margin-left 10px
  vertical-align bottom
}
</style>



// WEBPACK FOOTER //
// src/pages/adminCenter/page/article/tendering/add.vue